import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { class: "flex -my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    filters: _ctx.filters,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters) = $event)),
    selection: _ctx.state.selectedDataRow,
    "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedDataRow) = $event)),
    class: "p-datatable-md",
    "column-resize-mode": "fit",
    "resizable-columns": true,
    "responsive-layout": "scroll",
    lazy: true,
    "selection-mode": "multiple",
    value: _ctx.getCompareList,
    "filter-display": "menu",
    "data-key": "id",
    onRowSelect: _ctx.onRowSelect
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        "selection-mode": "multiple",
        style: {"width":"40px"},
        exportable: false
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.selectedColumns, (col, index) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: col.field + '_' + index,
          field: col.field,
          header: col.header,
          sortable: false,
          "filter-field": col.field,
          "show-filter-match-modes": false
        }, {
          body: _withCtx(({ data }) => [
            (col.field == 'link')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "router-link link",
                  to: { name: 'research-equipment-detail', params: { id: data.id } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      icon: "icon-search",
                      class: "p-button-outlined"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true),
            (col.field == 'number')
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(data[col.field]), 1))
              : _createCommentVNode("", true),
            (col.field == 'name')
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(data[col.field]), 1))
              : _createCommentVNode("", true),
            (col.field == 'location')
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(data[col.field].street) + ", " + _toDisplayString(data[col.field].postalCode) + " " + _toDisplayString(data[col.field].cityName), 1))
              : _createCommentVNode("", true),
            (col.field == 'researchOrganization')
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(data[col.field].name), 1))
              : _createCommentVNode("", true),
            (col.field == 'contactUsers')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(data.contactUsers, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("p", null, _toDisplayString(item.firstname) + " " + _toDisplayString(item.lastname), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["field", "header", "filter-field"]))
      }), 128)),
      _createVNode(_component_Column, {
        header: "",
        "header-style": "text-align:center; width: 108px;"
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-outlined p-button-danger ml-2",
              onClick: ($event: any) => (_ctx.removeFromCompare(data))
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["filters", "selection", "value", "onRowSelect"]))
}